import { useCallback, useEffect } from "react";
import { getToken } from "../../graphql/token";
import { useDeleteCompanyUserTokenMutation } from "../../graphql/generated/graphql";

export default function Logout() {
  const token = getToken();

  if (!token) {
    window.location.href = "/";
  }

  const [deleteCompanyUserToken] = useDeleteCompanyUserTokenMutation();
  const handleOnLogout = useCallback(async () => {
    await deleteCompanyUserToken({
      variables: {
        input: {
          token: token || "",
        },
      },
    });
    localStorage.removeItem("token");
    window.location.href = "/";
  }, [deleteCompanyUserToken, token]);

  useEffect(() => {
    handleOnLogout();
  }, [handleOnLogout]);

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-purple-500"></div>
    </div>
  );
}
